import { render, staticRenderFns } from "./batch-collector-level.vue?vue&type=template&id=366a73a2&scoped=true"
import script from "./batch-collector-level.vue?vue&type=script&lang=ts"
export * from "./batch-collector-level.vue?vue&type=script&lang=ts"
import style0 from "./batch-collector-level.vue?vue&type=style&index=0&id=366a73a2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366a73a2",
  null
  
)

export default component.exports